import CheckboxSelectColumn from './slick.checkboxselectcolumn';
export default CheckboxSelectColumn;
